import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCrowdNoise = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Capa_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 468.492 468.492",
	style: { enableBackground: "new 0 0 468.492 468.492" },
	xmlSpace: "preserve",
	...props,
	children: [
		/* @__PURE__ */ _jsxs("g", {
			id: "XMLID_193_",
			children: [
				/* @__PURE__ */ _jsx("path", {
					id: "XMLID_199_",
					d: "M271.765,249.637c5.93-2.704,8.533-9.698,5.822-15.628l-39.345-86.144 c-2.421-5.331-7.416-7.047-13.454-7.047h-42.193c-6.037,0-11.217,1.801-13.561,7.271l-24.467,56.551l13.191,28.888l12.501-28.904 c0,32.864-0.03,52.858-0.03,56.222l16.763,36.725c5.546,12.158,0.184,26.515-11.966,32.069c-1.564,0.712-3.173,1.225-4.797,1.592 v17.75c0,7.813,6.344,14.148,14.156,14.148c7.815,0,14.158-6.336,14.158-14.148v-84.353h10.311v84.353 c0,7.813,6.344,14.148,14.158,14.148c7.813,0,14.156-6.336,14.156-14.148c0-69.997-0.045-139.379-0.045-146.795l19.013,41.628 C258.835,249.722,265.805,252.357,271.765,249.637z"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "XMLID_198_",
					d: "M203.83,136.55c16.455,0,29.77-13.314,29.77-29.746c0-16.44-13.315-29.754-29.77-29.754 c-16.409,0-29.754,13.314-29.754,29.754C174.076,123.236,187.421,136.55,203.83,136.55z"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "XMLID_197_",
					d: "M176.558,302.335l-42.426-92.947c-2.649-5.791-8.12-7.614-14.539-7.614H75.115l-28.559-21.397 L25.29,129.61l21.711-47.205c20.623,26.23,66.234-1.839,82.812,33.232c8.488-18.462,16.977-36.909,25.465-55.379 C138.699,25.194,93.088,53.278,72.45,27.04l5.086-11.054c1.547-3.355,0.077-7.339-3.278-8.879c-3.402-1.57-7.324-0.077-8.887,3.287 l-50.5,109.831c-2.328-0.406-4.733-0.406-7.062,0.582c-6.481,2.712-9.531,10.166-6.819,16.654l24.76,59.126l35.023,26.238 c0,97.382-0.06,62.55-0.06,203.537c0,8.435,6.849,15.267,15.276,15.267c8.427,0,15.275-6.832,15.275-15.267v-90.994h11.139v90.994 c0,8.435,6.849,15.267,15.275,15.267c8.427,0,15.274-6.832,15.274-15.267c0-84.796-0.045-130.775-0.045-158.332l20.485,44.877 c2.926,6.404,10.479,9.192,16.867,6.288C176.65,316.278,179.47,308.731,176.558,302.335z"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "XMLID_196_",
					d: "M336.361,208.362c17.113,0,30.98-13.874,30.98-30.996s-13.867-30.988-30.98-30.988 c-17.115,0-30.98,13.866-30.98,30.988S319.246,208.362,336.361,208.362z"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "XMLID_195_",
					d: "M96.842,136.55c-16.44,0-29.754,13.308-29.754,29.754c0,16.425,13.313,29.747,29.754,29.747 c16.424,0,29.753-13.322,29.753-29.747C126.595,149.857,113.265,136.55,96.842,136.55z"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "XMLID_194_",
					d: "M443.227,5.698c-37.355-10.373-45.935,42.486-79.274,40.97l-5.039-11.062 c-1.549-3.371-5.561-4.857-8.872-3.31c-3.37,1.532-4.855,5.5-3.324,8.871l52.246,114.619l-8.748,28.506l-31.134,30.023h-46.424 c-4.733,0-13.16,3.577-15.49,9.889l-36.863,99.827c-2.543,6.864,0.966,14.487,7.83,17.022c6.925,2.551,14.494-1.004,17.021-7.845 l13.651-36.97c0,7.898-0.046,30.329-0.046,152.002c0,8.788,7.125,15.904,15.903,15.904c8.779,0,15.903-7.116,15.903-15.904v-94.777 h11.584v94.777c0,8.788,7.124,15.904,15.903,15.904c8.778,0,15.903-7.116,15.903-15.904c0-152.509-0.03-58.896-0.03-211.434 l37.14-35.814c1.623-1.556,2.819-3.502,3.478-5.646l13.834-45.076c2.145-7.001-1.777-14.417-8.779-16.562 c-5.301-1.647-10.771,0.191-14.079,4.175l-16.287-35.76c33.339,1.509,41.903-51.342,79.257-40.977 C460.065,42.668,451.654,24.183,443.227,5.698z"
				})
			]
		}),
		/* @__PURE__ */ _jsx("g", {}),
		/* @__PURE__ */ _jsx("g", {}),
		/* @__PURE__ */ _jsx("g", {}),
		/* @__PURE__ */ _jsx("g", {}),
		/* @__PURE__ */ _jsx("g", {}),
		/* @__PURE__ */ _jsx("g", {}),
		/* @__PURE__ */ _jsx("g", {}),
		/* @__PURE__ */ _jsx("g", {}),
		/* @__PURE__ */ _jsx("g", {}),
		/* @__PURE__ */ _jsx("g", {}),
		/* @__PURE__ */ _jsx("g", {}),
		/* @__PURE__ */ _jsx("g", {}),
		/* @__PURE__ */ _jsx("g", {}),
		/* @__PURE__ */ _jsx("g", {}),
		/* @__PURE__ */ _jsx("g", {})
	]
});
export default SvgCrowdNoise;
